"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KlassCodeInput = void 0;
var _SuiTurnstile = require("schoolUiComponents/SuiTurnstile");
var _api = require("../api");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var INITIAL_STATE = ["", "", "", "", "", ""];
var KlassCodeInput = exports.KlassCodeInput = function KlassCodeInput() {
  var _useState = (0, _react.useState)([].concat(INITIAL_STATE)),
    _useState2 = _slicedToArray(_useState, 2),
    klassCode = _useState2[0],
    setKlassCode = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    focusedBox = _useState4[0],
    setFocusedBox = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    success = _useState0[0],
    setSuccess = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isTyping = _useState10[0],
    setIsTyping = _useState10[1];
  var _useState11 = (0, _react.useState)(''),
    _useState12 = _slicedToArray(_useState11, 2),
    inputMethod = _useState12[0],
    setInputMethod = _useState12[1];
  var _useSuiTurnstileState = (0, _SuiTurnstile.useSuiTurnstileState)(),
    token = _useSuiTurnstileState.token,
    refreshToken = _useSuiTurnstileState.refreshToken,
    isTurnstileLoading = _useSuiTurnstileState.isTurnstileLoading;
  (0, _react.useEffect)(function () {
    var klassCodeValue = (klassCode === null || klassCode === void 0 ? void 0 : klassCode.join("").trim()) || "";
    if ((klassCodeValue === null || klassCodeValue === void 0 ? void 0 : klassCodeValue.length) === 6 && isValidText(klassCodeValue)) {
      setLoading(true);
      setSuccess(null);
      setError(null);
      trackEventsForGuests("Class Login Attempted", {
        "mp_login_user_type": "student",
        "Login Method": "Class code"
      }, {
        send_mixpanel: true
      });
      _api.APIS.klassCodeLogin(klassCodeValue, false, token).then(function (res) {
        setLoading(false);
        setSuccess("Great job!");
        window.location.href = "/klass/student_roster?loginMethod=Class code&fromPage=Class code input screen";
      })["catch"](function (err) {
        setLoading(false);
        setError("Oops, try again!");
        refreshToken();
        setTimeout(function () {
          setKlassCode([].concat(INITIAL_STATE));
          setFocusedBox(0);
        }, 1000);
      });
    } else {
      if (success) {
        setSuccess(null);
      }
      if (error) {
        setError(null);
      }
    }
  }, [klassCode]);
  function isValidText(text) {
    var regex = /^[A-Za-z]+$/;
    return regex.test(text);
  }
  var sendInteractedEvent = function sendInteractedEvent(_ref) {
    var _ref$interactionDetai = _ref.interactionDetails,
      interactionDetails = _ref$interactionDetai === void 0 ? '' : _ref$interactionDetai,
      _ref$clickedOn = _ref.clickedOn,
      clickedOn = _ref$clickedOn === void 0 ? '' : _ref$clickedOn;
    trackEventsForGuests("Interacted Class Code Input Screen", {
      "mp_login_user_type": "student",
      "Interaction details": interactionDetails,
      "Clicked on": clickedOn
    }, {
      send_mixpanel: true
    });
  };
  var handleCodeChange = function handleCodeChange(index, value) {
    var _value, _value2, _value3, _value6;
    if (!isTyping && inputMethod !== 'pasted') {
      sendInteractedEvent({
        interactionDetails: "Started typing"
      });
      setIsTyping(true);
    }
    value = ((_value = value) === null || _value === void 0 || (_value = _value.trim()) === null || _value === void 0 || (_value = _value.split("")) === null || _value === void 0 ? void 0 : _value.slice(0, 6).join("")) || "";
    if ((_value2 = value) !== null && _value2 !== void 0 && _value2.length && !isValidText(value)) {
      return;
    }
    if (((_value3 = value) === null || _value3 === void 0 ? void 0 : _value3.length) > 1 && isValidText(value)) {
      var _value4, _value5;
      setKlassCode(_toConsumableArray(klassCode.map(function (code, i) {
        return i >= index ? value[i - index] || code : code;
      })));
      setFocusedBox(index + ((_value4 = value) === null || _value4 === void 0 ? void 0 : _value4.length) >= 6 ? 0 : index + ((_value5 = value) === null || _value5 === void 0 ? void 0 : _value5.length));
      return;
    }
    klassCode[index] = ((_value6 = value) === null || _value6 === void 0 ? void 0 : _value6.toUpperCase()) || "";
    setKlassCode(_toConsumableArray(klassCode));
    if (value) {
      setFocusedBox((index + 1) % 6);
    } else {
      setFocusedBox(index === 0 ? 0 : index - 1);
    }
  };
  var setDataFromClipboard = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var text;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return navigator.clipboard.readText();
          case 1:
            text = _context.v;
            if ((text === null || text === void 0 ? void 0 : text.length) === 6 && isValidText(text)) {
              setKlassCode(text.split("").slice(0, 6));
              setFocusedBox(5);
            }
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function setDataFromClipboard() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "klass-code",
    "data-sentry-component": "KlassCodeInput",
    "data-sentry-source-file": "KlassCodeInput.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "klass-code-input"
  }, klassCode.slice(0, 6).map(function (codeChar, index) {
    return /*#__PURE__*/_react["default"].createElement("input", {
      key: "".concat(index, "-").concat(codeChar),
      ref: function ref(_ref4) {
        if (index === focusedBox) {
          _ref4 === null || _ref4 === void 0 || _ref4.focus();
        }
      },
      value: codeChar,
      onChange: function onChange(_ref3) {
        var target = _ref3.target;
        return !isTurnstileLoading && handleCodeChange(index, target === null || target === void 0 ? void 0 : target.value);
      },
      onPaste: function onPaste(event) {
        // setDataFromClipboard()
        setInputMethod('pasted');
        sendInteractedEvent({
          interactionDetails: "Copy pasted"
        });
      },
      className: "code-char ".concat(codeChar !== null && codeChar !== void 0 && codeChar.length ? "filled" : "", " ").concat(success ? "success" : "", " ").concat(error ? "error" : ""),
      tabIndex: index + 1,
      type: "text",
      maxLength: 6,
      autoComplete: "off",
      autoFocus: index === focusedBox,
      "data-test-id": "class-code-".concat(index, "-field")
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "info"
  }, isLoading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "loading"
  }, "Checking your class code\u2026"), error && /*#__PURE__*/_react["default"].createElement("div", {
    className: "error"
  }, error), success && /*#__PURE__*/_react["default"].createElement("div", {
    className: "success"
  }, success)), /*#__PURE__*/_react["default"].createElement("input", {
    className: "autocomplete-hide"
  }));
};